import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  Aux,
  BASE_URL,
  IsNullOrUndefined,
  LONG_DATE_FORMAT,
  TANK_ACTION_TYPE_DROPOFF,
  TANK_ACTION_TYPE_PICKUP,
  TANK_ASSET_TYPES_IDS,
} from "../../constants";
import Select from "react-select";
import TextViewControl from "../Common/TextViewControl";
import moment from "moment";
import CheckBoxControl from "../Common/CheckBoxControl";

class LocationTankView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      tank: props.tank,
      validationMessages: {},
      selectedTank: null,
      // Asset types depend on tank asset type ids allowed for assignment
      assetTypes: [
        {
          value: `${TANK_ASSET_TYPES_IDS.CollectionBulk}`,
          label: "Collection",
        },
        {
          value: `${TANK_ASSET_TYPES_IDS.FreshOilBulk}`,
          label: "Fresh Oil",
        },
      ],
      selectedAssetType: `${TANK_ASSET_TYPES_IDS.CollectionBulk}`,
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleOnNewRequest = this.handleOnNewRequest.bind(this);
    this.validate = this.validate.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let { tank } = this.props;
    let prevTank = prevProps.tank;

    if (
      IsNullOrUndefined(prevTank) &&
      !IsNullOrUndefined(tank) &&
      IsNullOrUndefined(this.state.tank)
    ) {
      this.setState({ tank, selectedTank: null });
    } else if (
      !IsNullOrUndefined(prevTank) &&
      !IsNullOrUndefined(tank) &&
      tank.tankRequestId !== prevTank.tankRequestId
    ) {
      this.setState({ tank, selectedTank: null });
    } else if (!IsNullOrUndefined(prevTank) && IsNullOrUndefined(tank)) {
      this.setState({ tank, selectedTank: null });
    }
  }

  handleFieldChange(e) {
    let { tank } = this.state;

    if (e.target.type === "checkbox") {
      tank[e.target.name] = e.target.checked;
    } else {
      tank[e.target.name] = e.target.value;
    }

    this.setState(
      {
        tank,
      },
      this.validate
    );
  }

  handleOnNewRequest(e) {
    e.preventDefault();
    let { tank } = this.state;

    this.validate(() => {
      if (this.isValid()) {
        this.props.onNewRequest(tank);
        this.setState({
          selectedAssetType: `${TANK_ASSET_TYPES_IDS.CollectionBulk}`,
        });
      }
    });
  }

  validate(afterValidate) {
    let validationMessages = {};
    let { tank } = this.state;

    if (IsNullOrUndefined(tank.tankSizeId)) {
      validationMessages["tankSizeId"] = "Please select";
    }

    this.setState({ validationMessages }, afterValidate);
  }

  isValid() {
    let { validationMessages } = this.state;

    return Object.keys(validationMessages).length === 0;
  }

  handleTankChange = (val) => {
    let validationMessages = { ...this.state.validationMessages };
    if (validationMessages.tankSizeId) {
      delete validationMessages.tankSizeId;
    }
    this.setState({
      tank: {
        ...this.state.tank,
        tankSizeId: val.tankSizeId,
        hasHeater: val.hasHeater,
        tankAssetTypeId: val.tankAssetTypeId,
      },
      selectedTank: val,
      validationMessages,
    });
  };

  /**
   * @param {number} assetType
   */
  handleAssetTypeChange(assetType) {
    this.setState({
      selectedAssetType: assetType,
      selectedTank: null,
    });
  }

  render() {
    let { isOpen, onCancel, availableTanks } = this.props;
    let {
      tank,
      validationMessages,
      selectedTank,
      assetTypes,
      selectedAssetType,
    } = this.state;
    let isValid = this.isValid();
    let isNew =
      !IsNullOrUndefined(tank) &&
      IsNullOrUndefined(tank.tankRequestId) &&
      IsNullOrUndefined(tank.tankId);
    let canDelete =
      !IsNullOrUndefined(tank) &&
      (IsNullOrUndefined(tank.tankId) ||
        tank.tankRequestAction === TANK_ACTION_TYPE_PICKUP) &&
      IsNullOrUndefined(tank.tankRequestActionCompleteDate);
    return !IsNullOrUndefined(tank) ? (
      <div>
        <Modal style={{ maxWidth: "650px" }} isOpen={isOpen} toggle={onCancel}>
          <ModalHeader>{isNew ? "New Tank Request" : "View Tank"}</ModalHeader>
          <ModalBody>
            {isNew ? (
              <div className="form-horizontal col-12">
                <div className="form-group row">
                  <label className="col-md-2 form-control-label">
                    Asset Type
                  </label>
                  <div
                    className="col-md-10 col-sm-12 col-xs-12 flex"
                    style={{ gap: "1rem" }}
                  >
                    {assetTypes.map((asset) => (
                      <div
                        key={asset.value}
                        className="flex align-items-center"
                        style={{ gap: "0.25rem" }}
                      >
                        <input
                          type="radio"
                          name="assetType"
                          id={`asset-${asset.value}`}
                          value={asset.value}
                          onChange={(e) => {
                            this.handleAssetTypeChange(e.target.value);
                          }}
                          checked={asset.value === selectedAssetType}
                        />
                        <label
                          htmlFor={`asset-${asset.value}`}
                          className="form-check-label"
                          style={{ paddingLeft: 0 }}
                        >
                          {asset.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-md-2 form-control-label"
                    htmlFor="locationTypeUniqueCode"
                  >
                    Tank
                  </label>
                  <div className="col-md-10 col-sm-12 col-xs-12">
                    <Select
                      name="tanks"
                      value={selectedTank}
                      multi={false}
                      clearable={false}
                      simpleValue={false}
                      options={availableTanks.filter(
                        (x) =>
                          x.tankAssetTypeId ===
                          Number.parseInt(selectedAssetType || "1")
                      )}
                      onChange={(val) => {
                        this.handleTankChange(val);
                      }}
                    />
                  </div>
                  {!IsNullOrUndefined(validationMessages["tankSizeId"]) && (
                    <div style={{ color: "red" }}>
                      {validationMessages["tankSizeId"]}
                    </div>
                  )}
                </div>
                <CheckBoxControl
                  labelText={"At Location"}
                  value={tank.tankAlreadyAtLocation}
                  name={"tankAlreadyAtLocation"}
                  onChange={(e) => {
                    this.setState({
                      tank: {
                        ...tank,
                        tankAlreadyAtLocation: e.target.checked,
                      },
                    });
                  }}
                />
              </div>
            ) : (
              <div className="form-horizontal col-12">
                {
                  // Open tank request (tankId null)tankRequestId not null
                  // Pending tank request (tankId not null)
                  // Tank not from request
                }

                {!IsNullOrUndefined(tank.tankRequestId) ? (
                  <Aux>
                    <h6>Tank Request Information</h6>
                    <TextViewControl labelText={"Tank"} value={tank.tankName} />
                    <TextViewControl
                      labelText={"Action"}
                      value={tank.tankRequestActionString}
                    />
                    <TextViewControl
                      labelText={"Heater"}
                      value={tank.tankRequestHasHeater ? "Yes" : "No"}
                    />
                    <TextViewControl
                      labelText={"Created"}
                      value={`${moment(tank.tankRequestCreatedDate).format(
                        LONG_DATE_FORMAT
                      )} By ${tank.tankRequestCreatedByUserName || "System"}`}
                    />
                    {!IsNullOrUndefined(tank.tankRequestTankAssignedDate) ? (
                      <Aux>
                        <TextViewControl
                          labelText={"Assigned"}
                          value={`${moment(
                            tank.tankRequestTankAssignedDate
                          ).format(LONG_DATE_FORMAT)} By ${
                            tank.tankRequestTankAssignedByUserName || "System"
                          }`}
                        />
                      </Aux>
                    ) : (
                      <TextViewControl
                        labelText={"Assigned"}
                        value={"Not yet assigned a tank"}
                      />
                    )}
                    {!IsNullOrUndefined(tank.tankRequestActionCompleteDate) ? (
                      <Aux>
                        <TextViewControl
                          labelText={"Completed"}
                          value={`${moment(
                            tank.tankRequestActionCompleteDate
                          ).format(LONG_DATE_FORMAT)} By ${
                            tank.tankRequestCompletedByUserName || "System"
                          }`}
                        />
                      </Aux>
                    ) : (
                      <TextViewControl
                        labelText={"Completed"}
                        value={"Not yet completed"}
                      />
                    )}
                    {!IsNullOrUndefined(tank.tankRequestRunId) && (
                      <div className="form-group row">
                        <label className="col-md-2 col-xs-3 col-sm-3 form-control-label">
                          Run
                        </label>
                        <div className="col-md-10 col-xs-10 col-sm-10 ">
                          <a
                            href={`${BASE_URL}/runs/search/${tank.tankRequestRunId}/locations/${tank.locationId}`}
                            target={"_blank"}
                          >
                            #{tank.tankRequestRunId}
                          </a>
                        </div>
                      </div>
                    )}
                  </Aux>
                ) : (
                  <Aux>
                    <h6>No Tank Request Information Available</h6>
                    <div className="form-group row">
                      <label className="col-12 form-control-label">
                        This tank was assigned before tank requests
                      </label>
                    </div>
                  </Aux>
                )}
                {!IsNullOrUndefined(tank.tankId) && (
                  <Aux>
                    <h6>Tank Information</h6>
                    <div className="form-group row">
                      <label className="col-md-2 col-xs-3 col-sm-3 form-control-label">
                        Tank #
                      </label>
                      <div className="col-md-10 col-xs-10 col-sm-10 ">
                        <a
                          href={`${BASE_URL}/manage/tanks/${tank.tankId}`}
                          target={"_blank"}
                        >
                          #{tank.tankId} {tank.tankName}
                        </a>
                      </div>
                    </div>
                    <TextViewControl
                      labelText={"Heater"}
                      value={tank.tankHasHeater ? "Yes" : "No"}
                    />
                    <TextViewControl
                      labelText={"Active"}
                      value={`${
                        tank.tankIsInactive
                          ? `No (${tank.tankStatusTypeString})`
                          : "Yes"
                      }`}
                    />
                    <TextViewControl
                      labelText={"Pending"}
                      value={tank.tankIsConsideredPending ? "Yes" : "No"}
                    />
                    <TextViewControl
                      labelText={"Location"}
                      value={tank.tankCurrentTankLocationName}
                    />
                    <div className="form-group row">
                      <label className="col-md-2 col-xs-3 col-sm-3 form-control-label">
                        Last lat/lng
                      </label>
                      <div className="col-md-8 col-xs-10 col-sm-10 ">
                        {IsNullOrUndefined(tank.tankLatitude) ||
                        IsNullOrUndefined(tank.tankLongitude) ? (
                          "Unknown"
                        ) : (
                          <a
                            href={`http://maps.google.com/maps?&z=21&q=${tank.tankLatitude}+${tank.tankLongitude}`}
                            target={"_blank"}
                          >{`${tank.tankLatitude}, ${tank.tankLongitude}`}</a>
                        )}
                      </div>
                    </div>
                  </Aux>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            {(!IsNullOrUndefined(tank.tankRequestId) || isNew) &&
              (isNew ? (
                <Button
                  color={"primary"}
                  disabled={!isValid}
                  onClick={this.handleOnNewRequest}
                >
                  Save
                </Button>
              ) : (
                <Button
                  color={"danger"}
                  disabled={!canDelete}
                  className={"ml-1"}
                  onClick={() => this.props.onDeleteRequest(tank)}
                >
                  Delete Request
                </Button>
              ))}

            {!IsNullOrUndefined(tank.tankId) &&
              tank.tankRequestAction !== TANK_ACTION_TYPE_PICKUP &&
              tank.tankAssignedToLocation && (
                <Button
                  color={"warning"}
                  className={"ml-1"}
                  onClick={() => this.props.onPickupRequest({...tank, tankAssetTypeId: 1})}
                >
                  Request Pickup
                </Button>
              )}

            <Button
              color={"secondary"}
              className={"ml-1"}
              onClick={(e) => onCancel()}
            >
              Back
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    ) : null;
  }
}

LocationTankView.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  tank: PropTypes.object,
  onNewRequest: PropTypes.func.isRequired,
  onDeleteRequest: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  availableTanks: PropTypes.array.isRequired,
  onPickupRequest: PropTypes.func.isRequired,
};

export default LocationTankView;
